import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Input = ({
    className = '',
    onChange = f => f,
    onClick = f => f,
    placeholder = '',
    value = '',
    type = 'text',
    autoComplete = 'off',
    disabled = false,
    nativeDisabled = false,
    size = 20,
    inputEl,
    id,
    name,
    inputMode,
    maxlength,
    onBlur,
    onFocus,
}) => {

    return (
        <div className={classNames('Input', className, { disabled: disabled })}>
            <input
                ref={inputEl}
                autoComplete={autoComplete}
                className="Input__input"
                id={id}
                name={name}
                inputMode={inputMode}
                type={type}
                onBlur={onBlur}
                onClick={(e) => !disabled && onClick(e)}
                onChange={onChange}
                onFocus={onFocus}
                placeholder={placeholder}
                value={value}
                disabled={disabled || nativeDisabled}
                maxLength={maxlength}
                size={Math.max(2, size)}
            />
        </div>
    );
}

Input.defaultProps = {
    className: '',
    onChange: f => f,
    onClick: f => f,
    placeholder: '',
    icon: null,
    value: '',
    type: 'text',
    autoComplete: 'off',
    disabled: false,
    nativeDisabled: false,
    textBefore: '',
    textAfter: '',
    size: 20,
    withCopy: false
};

Input.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    inputMode: PropTypes.string,
    onKeyPress: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    maxlength: PropTypes.number,
    type: PropTypes.string,
    autoComplete: PropTypes.string,
    disabled: PropTypes.bool,
    nativeDisabled: PropTypes.bool,
    size: PropTypes.number,
};

export default Input;